module.exports = __webpack_public_path__ + "img/android-small-overlay.09161a03.png";